export default "__VITE_ASSET__BPFR_nlz__"